import { render, staticRenderFns } from "./CsContratoNacionalTarifario.vue?vue&type=template&id=22f3f558"
import script from "./CsContratoNacionalTarifario.vue?vue&type=script&lang=js"
export * from "./CsContratoNacionalTarifario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports